export default "__VITE_ASSET__GJRYYeDa__"